import { inject } from '@angular/core'
import type { ResolveFn } from '@angular/router'
import { RedirectCommand, Router } from '@angular/router'
import { catchError, of } from 'rxjs'
import { map } from 'rxjs'

import type { VerifyDeviceData } from '@app/modules/verify-device/verify-device.model'
import { VerifyDeviceService } from '@app/services/verify-device.service'

export const verifyDeviceResolver: ResolveFn<string> = () => {
  const router = inject(Router)
  const verifyDeviceService = inject(VerifyDeviceService)
  const loginRedirect = new RedirectCommand(router.parseUrl('/login'))

  return verifyDeviceService.data().pipe(
    map((data: VerifyDeviceData) => data?.email || loginRedirect),
    catchError(() => of(loginRedirect)),
  )
}
